import React from "react";

function WidgetButton({ buttonClass, titleText, thumbnailImage, handleClick }) {
    return (
        <div className={"buttonBox " + buttonClass} onClick={handleClick}>
            <div className="buttonimg fl">
                <img src={thumbnailImage} />
            </div>
            <div className="buttontxt fl">{titleText}</div>
        </div>
    );
}

export default WidgetButton;
